import { composeReducers } from 'common/util/composeReducers';

import { ACTIONS } from 'common/actions/pinnedBinderToggle';

export function setBinderPinReducer(state, action) {
    if (action && action.type !== ACTIONS.SET_BINDER_PIN) { return state; }

    return state;
}

export function settingBinderPinReducer(state, action) {
    if (action && action.type !== ACTIONS.SETTING_BINDER_PIN) { return state; }

    return state;
}

export default composeReducers(setBinderPinReducer, settingBinderPinReducer);
